module.exports = __webpack_public_path__ + "img/background.ae87ffdc.png";